// extracted by mini-css-extract-plugin
module.exports = {"advertisingButton":"_gCfEZs4P","container":"_FswSvFYG"};